import styled from 'styled-components';
import { darken, desaturate } from 'polished';

export interface ButtonProps {
  width?: string;
  textColor: string;
  backgroundColor: string;
  active: boolean;
}

export const Container = styled.button<ButtonProps>`
  flex: 1;
  width: ${(props) => props.width || '100%'};
  min-height: 35px;
  max-height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  gap: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 12px;
  white-space: nowrap;
  background-color: ${({ backgroundColor, active }) =>
    active ? backgroundColor : desaturate(1, backgroundColor)};
  color: ${({ textColor }) => textColor};
  transition: 0.2s;

  &:hover {
    background-color: ${({ backgroundColor, active }) =>
      active ? darken(0.1, backgroundColor) : darken(0.1, desaturate(1, backgroundColor))};
  }
`;
